import Axios from "axios";
import {
    SET_WAREHOUSE_LIST,
    UNSET_WAREHOUSE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateWarehouse, getWarehouseList, generateWarehouseCode } from "@/store/api";
// initial state
const state = {
  getWarehouseList: [],
};

const getters = {
  getWarehouseList(state) {
    return state.getWarehouseList;
  }
};

const mutations = {
  [SET_WAREHOUSE_LIST](state, data) {
    state.getWarehouseList = data;
  },
  [UNSET_WAREHOUSE_LIST](state) {
    state.getWarehouseList = [];
  }
};

const actions = {

  saveUpdateWarehouse({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateWarehouse, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getWarehouseList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getWarehouseList, data)
        .then(function (response) {
          commit('SET_WAREHOUSE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_WAREHOUSE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getGeneratedWarehouseCode({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(generateWarehouseCode)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
